import type { InputProps } from 'antd';
import { Input } from 'antd';
import cn from 'classnames';
import { Controller, useFormContext } from 'react-hook-form';

import { FieldValidationMessage } from '../FieldValidationMessage/FieldValidationMessage';

import styles from './Field.module.scss';

interface IInputProps extends InputProps {
  fieldName: string;
  shouldEnableLengthCounter?: boolean;
  maxLengthCount?: number;
}

export const InputField = ({ fieldName, shouldEnableLengthCounter, maxLengthCount = 0, ...restProps }: IInputProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field, fieldState: { invalid: isInvalid, error } }) => (
        <div className={styles['field-wrapper']}>
          <Input
            {...field}
            {...restProps}
            status={isInvalid ? 'error' : undefined}
            suffix={
              shouldEnableLengthCounter ? (
                <p className={cn({ [styles['length-counter-danger']]: String(field.value).length > maxLengthCount })}>
                  {String(field.value).length} / {maxLengthCount}
                </p>
              ) : null
            }
          />
          {isInvalid && <FieldValidationMessage message={error?.message} />}
        </div>
      )}
    />
  );
};
